var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 16.286,
    viewBox: "0 0 14.857 16.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4430",
    "data-name": "Group 4430",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3130",
    "data-name": "Group 3130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8477",
    "data-name": "Path 8477",
    d: "M10.87,5.059V5.2a4.156,4.156,0,1,0-8.311,0V5.059a3.709,3.709,0,0,1-.925,2.506A2.1,2.1,0,0,0,1,8.916v.531a2.241,2.241,0,0,0,2.286,2.071h6.857a2.241,2.241,0,0,0,2.286-2.071V8.916A2.1,2.1,0,0,0,11.8,7.565,3.706,3.706,0,0,1,10.87,5.059Z",
    transform: "translate(-0.286 -0.286)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8478",
    "data-name": "Path 8478",
    d: "M10.029,16.546a1.715,1.715,0,1,1-3.429,0",
    transform: "translate(-1.886 -4.727)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.3501764a511fbf67d1c3d0f848dd9fad.svg";
export { ForwardRef as ReactComponent };